import styled from 'styled-components'

import Button from 'components/atoms/Button'

const ImportButton = styled(Button)``

export default ImportButton
